import type { Shelf, TransformedShelf } from '../types'

/**
 * Applies statistics calculation to shelf.
 *
 * Enriches the shelf statistics with derived metrics like percentage of unknown products.
 *
 * Type flow: TransformedShelf → Shelf (adds enriched statistics)
 */
export function applyStatisticsTransformation(shelf: TransformedShelf, shouldHideUnknownStatistics: boolean): Shelf {
  const statistics = shelf.statistics

  if (!statistics) return shelf

  const hasStockCount = shouldHideUnknownStatistics ? statistics.hasStockCount + statistics.unknownStockCount : statistics.hasStockCount
  const unknownStockCount = shouldHideUnknownStatistics ? 0 : statistics.unknownStockCount
  const totalStock = hasStockCount + statistics.noStockCount + unknownStockCount

  return {
    ...shelf,
    statistics: {
      ...statistics,
      hasStockCount,
      unknownStockCount,
      shareOfUnknownProducts: !shouldHideUnknownStatistics && totalStock ? Math.round((unknownStockCount / totalStock) * 100) : undefined,
    },
  }
}

